export const PreQualifierAssetTypeSelectionViewUat = {
  title: 'preQualifierAssetType.title',
  description: 'preQualifierAssetType.description',
  paragraph: 'preQualifierAssetType.paragraph',
  selectButton: 'preQualifierAssetType.selectButton',
}
